import { Instance, types } from 'mobx-state-tree';

export const ActivityDayModel = types.model('ActivityDayModel', {
  done: types.boolean,
  maxDate: types.maybeNull(types.Date),
  entry: types.maybeNull(types.string),
  dateOfCompletion: types.maybeNull(types.Date),
});

export const ActivityModel = types.model('ActivityModel', {
  _id: types.identifier,
  language: types.string,
  completelyLoaded: types.boolean,
  type: types.maybe(types.enumeration(['audio', 'memo', 'journaling'])),
  title: types.maybeNull(types.string),
  shortDescription: types.maybeNull(types.string),
  estimatedTime: types.maybeNull(types.string),
  image: types.maybeNull(types.string),
  designSystemColor: types.maybeNull(types.string),
  challengeable: types.maybe(types.boolean),
  numberOfDays: types.maybeNull(types.number),
  sessionId: types.maybeNull(types.string),
  /** the legacy exercice this activity replaced (its Today card yields to the challenge) */
  migratedFromExercice: types.maybeNull(types.string),
  userActivityId: types.maybeNull(types.string),
  status: types.maybe(types.enumeration(['started', 'completed', 'stopped'])),
  isChallenge: types.maybe(types.boolean),
  reminderEnabled: types.maybe(types.boolean),
  reminderTime: types.maybeNull(types.string),
  days: types.array(ActivityDayModel),
});

export type IActivityModel = Instance<typeof ActivityModel>;
